import React from 'react';
import { Error403 } from '../../asset';
import PrimaryButton from '../../component/button/PrimaryButton';
import { t } from 'i18next';

const ErrorPage403 = () => {
  return (
    <div className='flex flex-col justify-center items-center'>
      <img src={Error403} alt='img-error-400' />
      <p className='font-sans font-bold text-4xl mt-[24px]'> Access Denied/Forbidden </p>
      <p className='font-sans font-bold text-2xl mt-[24px]'> 
        The page you’re trying to access has restricted access.
      </p>
      <p className='font-sans font-bold text-2xl '> 
        Please refer to your system administrator.
      </p>
      <PrimaryButton 
          styles='mt-[24px]'
          // action={() => setStartOpen(true)} 
          text={t("Go Back")} 
        />
    </div>
  );
};

export default ErrorPage403;